<script setup lang="ts"></script>

<template>
  <router-link to="/empresa/actividad">Agregar Actividad</router-link>
</template>

<style scoped></style>
